const market = {
	dsbz: 'Ожидаемые токены',
	kpsj: 'Обратный отсчёт до открытия / Время открытия',
	ykp: 'Торговля открыта',
	kpdjs: 'Обратный отсчёт до открытия',
	worning: 'Не финальная цена, только для справки',
	swapTab_1: 'Бессрочные контракты USDT',
	swapTab_2: 'Бессрочные контракты в монете',
	searchCoin: 'Поиск монеты',
	risk: 'Предупреждение о риске',
	addSelfCode: 'Добавить в избранное',
	pair: 'Пара',
	latestPrice: 'Последняя цена',
	changeHour: 'Изменение за 24ч',
	highHour: 'Максимум за 24ч',
	lowHour: 'Минимум за 24ч',
	priceTrend: 'Тренд цены (3 дня)',
	volumeHour: 'Объём за 24ч',
	noSearch: 'Монеты не найдены',
	noAdd: 'Избранное пусто',
	noYet: 'Монета ещё не добавлена',
	noBi: 'Монеты ещё не добавлены',
	wan: '万', // 10k (оставлено иероглифом, т.к. условное обозначение)
	qian: '千', // 1k
	yi: '亿', // 100M
	yxhy: 'Бессрочный контракт',
	wghy: 'Сеточный контракт',
	cxjy:
		'Токены в инновационной зоне имеют определённые технические и рыночные достижения, но их цена может сильно колебаться, а риск — высок. Рекомендуем изучить相关资料 и принимать решение в пределах вашей толерантности к риску.',
	qljy:
		'Зона перспективной торговли находится на ранней стадии развития. BiKing не даёт никаких гарантий относительно консенсуса по стоимости или ликвидности. Пожалуйста, внимательно ознакомьтесь с информацией о проекте и инвестируйте осторожно, в пределах своих возможностей.',
	qljyDao: 'DAO-зона находится на ранней стадии развития. BiKing не даёт гарантий по стоимости или ликвидности. Изучите проект и инвестируйте осознанно.',
	default: 'Торговая зона на ранней стадии. BiKing не даёт гарантий. Изучите проект и инвестируйте ответственно.',
  storage: 'Зона хранения находится на ранней стадии. BiKing не даёт гарантий. Изучите проект и инвестируйте ответственно.',
	dlt:
		'Цифровые активы в зоне низкой ликвидности имеют низкую ликвидность и риск делистинга. Перед инвестированием рекомендуется тщательно взвесить риски.',
	defi:
		'DeFi-зона находится на ранней стадии развития. BiKing не даёт гарантий по стоимости или ликвидности. Изучите проект и инвестируйте осторожно.',
	nft: "NFT-зона находится на ранней стадии развития. BiKing не даёт гарантий по стоимости или ликвидности. Изучите проект и инвестируйте осторожно.",
	
	hz: "Бессрочный",
	yx: "Избранное",
	yjyzx: "Проекты исследовательского отдела",
	zx: 'Избранное',
	bb: 'Спот',
	hy: 'Фьючерс',
	zfb: 'Самый рост',
	xbb: 'Новые монеты',
	bd: 'Пара',
	zxj: 'Последняя цена',
	zdf24: 'Изменение за 24ч',
	high24: 'Максимум за 24ч',
	low24: 'Минимум за 24ч',
	turnover24: 'Объём за 24ч',
	zd24: 'Изм. за 24ч',
	zjrzd: 'Цена / дневное изменение',
	scgl: 'Обзор рынка',
	jysj: 'Торговые данные',
	fyje: "Сумма возврата комиссии",
	ms: "Да",
    mf: "Нет",
	是否交易: 'Торгует ли',
	推荐好友: 'Пригласить друга',
	推荐: "Рекомендовать",
	合约交易返佣: 'Получайте высокий возврат комиссии за фьючерсную торговлю',
	我的返佣比例: 'Мой процент возврата',
	好友返佣比例: 'Процент возврата друга',
	推荐码: 'Реферальный код',
	交易人数: 'Торгующих',
	推荐总览: 'Обзор рефералов',
	推荐人数: 'Приглашено',
	推荐链接: 'Реферальная ссылка',
	一键分享: 'Поделиться',
	合约返佣: 'Накопленный возврат по фьючерсам',
	推荐记录: 'История приглашений',
	返佣记录: 'История возвратов',
	请输入账户UID: 'Введите UID аккаунта',
	账户UID: 'UID аккаунта',
	注册时间: 'Время регистрации (UTC+8)',
	合约手续费: 'Комиссия за фьючерсы',
	返佣活动规则说明: 'Правила реферальной программы:',
	使用你的推荐链接: 'Пользователи, зарегистрировавшиеся по вашей реферальной ссылке или коду, считаются вашими рефералами. Если код не был указан, реферальная связь не устанавливается.',
	被邀请人产生的真实交易手续费: 'С реальной комиссии приглашённого пользователя пригласивший получает процент возврата. Возврат зачисляется на счёт пригласившего на следующий день, обычно после 4:00.',
	用户邀请朋友无上限: 'Количество приглашённых друзей не ограничено. Возврат начисляется только с комиссии за фьючерсную торговлю приглашённого.',
	被邀请人只有进行合约: 'Возврат начисляется только с комиссии за фьючерсную торговлю приглашённого.',
	不允许任何用户通过多: 'Запрещается накручивать рефералов через множественные аккаунты. При обнаружении все возвраты будут аннулированы, в том числе у приглашённых аккаунтов.',
	由于市场环境的改变: 'BiKing оставляет за собой право изменять правила возврата комиссии в зависимости от рыночных условий, рисков мошенничества и т.д.',
	保留对活动的最终解释权: 'По всем вопросам обращайтесь в службу поддержки.'
};

export { market };


// WEBPACK FOOTER //
// ./src/i18n/lang/market/ru.js